import { EnvironmentProviders, provideAppInitializer } from '@angular/core';
import { environment } from '@environments/environment';

/**
 * Provides the application with Brain Tab, the universal navigation widget for CS web properties
 * @returns app initializer provider
 */
export const provideMaze = (): EnvironmentProviders =>
    provideAppInitializer(() => {
        const initializerFn = mazeInitializer();
        return initializerFn();
    });

export const mazeInitializer = () => {
    return async () => {
        await new Promise<void>((resolve, _) => {
            if (environment.maze && environment.maze.url) {
                let t;
                try {
                    t = window.sessionStorage.getItem('maze-us');
                } catch (err) {
                    console.debug(err);
                }

                if (!t) {
                    t = new Date().getTime();
                    try {
                        window.sessionStorage.setItem('maze-us', t);
                    } catch (err) {
                        console.debug(err);
                    }
                }

                const script = document.createElement('script');
                script.src = `${environment.maze.url}?apiKey=${environment.maze.apiKey}`;
                script.async = true;

                script.onerror = async () => resolve(); // The script may have been blocked by an ad blocker
                script.onload = async () => resolve();

                document.head.appendChild(script);
                (window as any).mazeUniversalSnippetApiKey = environment.maze.apiKey;
                console.debug('[Injectors][MazeInjector] Successfully injected.');
            } else {
                console.debug('[Injectors][MazeInjector] Successfully injected.');
                resolve();
            }
        });
    };
};
